import { LeftOutlined, RightOutlined, ThunderboltFilled } from "@ant-design/icons";
import { Button } from "antd";
import Skeleton from "components/UI/skeleton";
import { useMSScheduleAdmins } from "queries/meetingSchedule";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";

/** Inisial dari nama (maks 2 huruf). */
const getInitials = (name = "") =>
  name
    .split(/[\s-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/** Warna avatar deterministik dari nama (agar konsisten antar render). */
const AVATAR_COLORS = [
  "#1677ff",
  "#13c2c2",
  "#52c41a",
  "#fa8c16",
  "#eb2f96",
  "#722ed1",
  "#f5222d",
  "#2f54eb",
];
const getAvatarColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash + name.charCodeAt(i)) % AVATAR_COLORS.length;
  }
  return AVATAR_COLORS[hash];
};

const SecondStepSchedule = ({ prev, dataForm, onChangeDataForm, skip }) => {
  const { t } = useTranslation();

  const { data: dataAdmin, isLoading } = useMSScheduleAdmins(
    {
      enabled:
        dataForm.dataGroup.auto_assign === 0 && dataForm.isDoneInitiateData,
    },
    {
      admin_group_id: dataForm.admin_group_id,
      per_page: 200,
    }
  );

  useEffect(() => {
    if (dataForm.dataGroup.auto_assign === 1) {
      skip();
    }
  }, [skip, dataForm]);

  const handleChangeSecondStep = useCallback(
    (value) => {
      onChangeDataForm({
        schedule_admin_id: value.id,
        modeForm: "calendar",
      });
    },
    [onChangeDataForm]
  );

  const handleChooseAuto = useCallback(() => {
    onChangeDataForm({
      schedule_admin_id: null,
      modeForm: "auto",
    });
  }, [onChangeDataForm]);
  return (
    <>
      <div>
        <div className="text-center text-xl font-semibold text-neutral-900">
          {t("meeting_schedule.title_second_step")}
        </div>
        <div className="mt-5">
          {isLoading ? (
            <Skeleton active />
          ) : (
            <div className="mx-auto grid max-w-xl grid-cols-1 gap-3">
              <button
                type="button"
                onClick={handleChooseAuto}
                className="group flex items-center gap-3 rounded-xl border border-primary/40 bg-primary/5 py-3.5 pl-4 pr-3 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary/40"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-white">
                  <ThunderboltFilled />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-semibold text-neutral-900">
                    {t("meeting_schedule.auto")}
                  </span>
                  <span className="text-xs text-neutral-500">
                    {t("meeting_schedule.auto_desc")}
                  </span>
                </span>
                <RightOutlined className="shrink-0 text-primary/50 transition-colors group-hover:text-primary" />
              </button>
              {dataAdmin?.data?.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => handleChangeSecondStep(item)}
                  className="group flex items-center gap-3 rounded-xl border border-neutral-200 bg-white py-3.5 pl-4 pr-3 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-neutral-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary/40"
                >
                  <span
                    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white"
                    style={{ backgroundColor: getAvatarColor(item.name) }}
                  >
                    {getInitials(item.name)}
                  </span>
                  <span className="min-w-0 flex-1 truncate font-semibold text-neutral-900">
                    {item.name}
                  </span>
                  <RightOutlined className="shrink-0 text-neutral-300 transition-colors group-hover:text-primary" />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="mx-auto mt-5 max-w-xl">
        <Button icon={<LeftOutlined />} onClick={() => prev()}>
          {t("meeting_schedule.previous")}
        </Button>
      </div>
    </>
  );
};

export default SecondStepSchedule;
